module.exports = __webpack_public_path__ + "static/media/condensed4BetaBadges.07f33da3.svg";